<template>
    <div>
		<div class="d-flex justify-content-between"
			:class="visible ? null : 'collapsed'"
			:aria-expanded="visible ? 'true' : 'false'"
			aria-controls="accordion-comment"
			@click="visible = !visible"
		>
			<span class="h6 font-weight-bold">{{$t('fmweb.opmerkingen')}}
                <span class="pl-1">
                    <i id="tooltip-target-1" class="fas fa-info-circle fa-lg fa-fw"></i>
                    <b-tooltip target="tooltip-target-1" triggers="hover">
                        <p>{{$t('fmweb.infoCommentaar')}}</p>
                    </b-tooltip>
                </span>
            </span>

			<span v-show="!visible" class=""><i class="far fa-plus-square fa-lg fa-fw"></i></span>
			<span v-show="visible" class=""><i class="far fa-minus-square fa-lg fa-fw"></i></span>
		</div>

        <b-collapse id="accordion-comment" v-model="visible" accordion="accordion-comment" role="tabpanel">
            <b-card-body class="pt-2 px-0">
                <b-form>
                    <b-form-textarea
                            :id="textAreaId"
                            :value="commentData.comments"
                            :class="{ error: $v.commentData.$error }"
                            class="comment"
                            @focusin="saveOriginalComments(), liveCountDown()"
                            @keypress="appendDateTime()"
                            @focusout="validate()"
                            @keyup="liveCountDown()"
                            rows="10">
                    </b-form-textarea>
                    <p>{{textareaLenght}}{{$t('fmweb.karaktersOver')}}</p>
                    <p v-if="!$v.commentData.maxLength" class="errorMessage"><b>{{$t('fmweb.karakterLimiet')}}</b></p>
                </b-form>
            </b-card-body>
        </b-collapse>
        <b-alert
                id="successAlert"
                :show="successAlert"
                variant="success"
                @dismissed="successAlert=0">
            <p class="alert-heading mb-0">{{$t('fmweb.successmelding')}}</p>
        </b-alert>
        <b-alert
                id="errorAlert"
                :show="errorAlert"
                variant="danger"
                @dismissed="errorAlert=0">
            <p class="alert-heading mb-0">{{$t('fmweb.errormelding')}}</p>
        </b-alert>
        <b-alert
                id="infoAlert"
                :show="infoAlert"
                variant="info"
                @dismissed="infoAlert=0">
            <p class="alert-heading mb-0">{{$t('fmweb.infomelding')}}</p>
        </b-alert>
    </div>
</template>

<script>
    import { dateTimeMixin } from "@/mixins/dateTimeMixin";
    import { uuidMixin } from "@/mixins/uuidMixin";
    import { maxLength } from "vuelidate/lib/validators"
    import CommentsCommand from "./commentsCommand";    
    import {mapActions, mapGetters} from "vuex";

    export default {
        mixins: [dateTimeMixin, uuidMixin],
        name: "Opmerkingen",
        props: {
            selectedInvoiceId: null
        },
        data() {
          return{
			visible: false,
            profile: this.$auth.profile,
            hover: true,
            focusable: true,
            standardOpen: [0],
            successAlert: 0,
            errorAlert: 0,
            infoAlert: 0,
            dismissSec: 6,
            commentData: this.invoice,
            textareaLenght: 7999,
            textAreaId: this.uuid(),
            originalComments: 0
          };
        },
        validations: {
            commentData: {
                maxLength: maxLength(7999)
            }
        },
        computed: {
            ...mapGetters('fmwebapp',['invoice']),
        },
        methods: {
            ...mapActions('fmwebapp', ['all', 'find', 'update', 'execute']),
        liveCountDown(){
            var value = document.getElementById(this.textAreaId).value;
            this.textareaLenght = 7999 - value.length;
        },
        saveOriginalComments(){
            this.originalComments = document.getElementById(this.textAreaId).value;
        },
        appendDateTime(){
            if (document.getElementById(this.textAreaId).value === this.originalComments){
                var amstime = this.getDateTime(1, "Europe");

                if (document.getElementById(this.textAreaId).value === ""){
                    document.getElementById(this.textAreaId).value += amstime + " <" + this.profile.name + ">" + "\n";
                } else {
                    document.getElementById(this.textAreaId).value += "\n" + amstime + " <" + this.profile.name + ">" + "\n";
                }
            }
        },
        storeComment(){
            var changes = {
                comments: document.getElementById(this.textAreaId).value.trim()
            }

            this.$store.commit('fmwebapp/update', {
                resource: "invoices",
                result: { ...this.invoice, ...changes }
            })

            const payload = {
                resource: "invoices",
                id: this.invoice.id,
                action: "comments",
                params: new CommentsCommand(this.invoice.comments)
            };
            
            this.execute(payload);

              this.successAlert = this.dismissSec;
        },
        validate(){
            var inputValue = document.getElementById(this.textAreaId).value.trim;
            let value = document.getElementById(this.textAreaId).value;

          if (value !== "") {
              if (value.length <= this.textareaLenght){
                  if (this.originalComments !== inputValue) {
                      this.storeComment();
                  } else {
                      this.infoAlert = this.dismissSec;
                  }
              } else {
                  this.errorAlert = this.dismissSec;
              }
          } else {
            if (this.originalComments !== inputValue) {
              this.storeComment();
            } else {
              this.infoAlert = this.dismissSec;
            }
          }
        },
        handleLoginEvent(data) {
          this.profile = data.profile;
        }
      },
      created() {
          var vm = this;
          vm.find({
              resource: 'invoices',
              id: this.selectedInvoiceId
          }).then(
              this.commentData = this.invoice
          );

          this.visible = this.commentData.comments != "" && this.commentData.comments != undefined
      }
    }
</script>
<style>
    .comment{
        margin-top: 10px !important;
        padding-left: 10px;
        padding-right: 10px;
    }

    #successAlert, #errorAlert, #infoAlert {
		width: 30vw;
		padding: 2em 3em; 
		position: fixed; 
		z-index: 100;
		top: 10vh;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		left: calc( 100% - 30vw );
		height: auto;
		box-shadow: 1px 1px 10px rgba(0,0,0,.5);
		transition: all .5s ease-in-out;
	}
    @media only screen and (max-width: 600px) {
        #successAlert, #errorAlert, #infoAlert {
            width: 50vw;
            left: calc( 100% - 50vw );
            height: auto;
        }
    }
    .errorMessage{
        color: red;
    }

    .fmcolors{
        color: white;
        border: 0 !important;
    }
</style>